import axios, { post } from "./https";

export const getAlllesson = params => {
    return axios({
        url:'lesson/getSearchLikeName',
        method:'get',
        params:params
    })
}

export const postCustomerMessage = data => {
    return axios({
        url: 'vip/saveUserInfo',
        method: 'POST',
        data: data,
    })
}

//获取课程包分类集合
export const lessonSort = params => {
    return axios({
        url:'lesson/getCateLists',
        method:'get',
        params:params
    })
}



//上传课程包信息
export const postCourse = data => {
    return axios({
        url: 'lesson/saveLessonInfo',
        headers: {
            'Content-Type':"multipart/form-data"
        },
        method: 'POST',
        data: data,
        
    })
}

//上传标签包信息

export const postLessonTag = data => {
    return axios({
        url: 'lesson/saveTagInfo',
        method: 'POST',
        data: data,
    })
}

//获取课程包标签集合
export const lessonTag = params => {
    return axios({
        url:'lesson/getTagLists',
        method:'get',
        params:params
    })
}

//获取所有会员列表
export const vipAll = params => {
    return axios({
        url:'vip/getLists',
        method:'get',
        params:params
    })
}


//上传分类
export const postSort = data => {
    return axios({
        url: 'lesson/saveCateInfo',
        headers: {
            'Content-Type':"multipart/form-data"
        },
        method: 'POST',
        data: data,
        
    })
}

//删除用户
export const removeVip = data => {
    return axios({
        url: 'vip/delUserVIp',
        method: 'POST',
        data: data,
    })
}

//获取课程包列表
export const lessonAll = params => {
    return axios({
        url:'lesson/getLists',
        method:'get',
        params:params
    })
}

//获取会员课程包列表
export const vipLessonAll = params => {
    return axios({
        url:'vip/getVipLessonLists',
        method:'get',
        params:params
    })
}

//添加用户课程包
export const addVipLesson = data => {
    return axios({
        url: 'vip/addVipLesson',
        method: 'POST',
        data: data,
    })
}

//获取会员详情页列表
export const getPersonDetail = params => {
    return axios({
        url:'vip/getUserVipDetail',
        method:'get',
        params:params
    })
}
//获取对应用户课程包的 章节详情页列表
export const getLessonChapterLists = params => {
    return axios({
        url:'vip/getVipLessonChapterLists',
        method:'get',
        params:params
    })
}

//获取对应用户核销记录
export const getUserVipDestroyLists = params => {
    return axios({
        url:'vip/getUserVipDestroyLists',
        method:'get',
        params:params
    })
}

//上传活动
export const saveActivityInfo = data => {
    return axios({
        url: 'lesson/saveActivityInfo',
        headers: {
            'Content-Type':"multipart/form-data"
        },
        method: 'POST',
        data: data,
        
    })
}

//获取活动详情
export const getActivityLists = params => {
    return axios({
        url:'lesson/getActivityLists',
        method:'get',
        params:params
    })
}

//上下架及删除活动
export const updateActivityStatus = data => {
    return axios({
        url: 'lesson/updateActivityStatus',
        method: 'POST',
        data: data,
    })
}

//删除分类
export const delCate = data => {
    return axios({
        url: 'lesson/delCate',
        method: 'POST',
        data: data,
    })
}

//删除标签
export const delTag = data => {
    return axios({
        url: 'lesson/delTag',
        method: 'POST',
        data: data,
    })
}
//课程包上热门
export const updateHot = data => {
    return axios({
        url: 'lesson/updateHot',
        method: 'POST',
        data: data,
    })
}

//课程包上下架
export const updateResource = data => {
    return axios({
        url: 'lesson/updateResource',
        method: 'POST',
        data: data,
    })
}

//通过手机号查找用户id
export const searchPhoneBindUserLists = params => {
    return axios({
        url: 'vip/searchPhoneBindUserLists',
        method: 'get',
        params:params
    })
}

//获取用户待核销列表
export const getUserVipTreatDestroyLists = params => {
    return axios({
        url: 'vip/getUserVipTreatDestroyLists',
        method: 'get',
        params:params
    })
}


//会员核销课程
export const destroyChapter = data => {
    return axios({
        url: 'vip/destroyChapter',
        method: 'POST',
        data: data,
    })
}

//管理员登录接口
export const login = data => {
    return axios({
        url: 'admin/login',
        method: 'POST',
        data: data,
    })
}

//删除课程包
export const delLesson = data => {
    return axios({
        url: 'lesson/delLesson',
        method: 'POST',
        data: data,
    })
}

//更改会员信息
export const updateUserInfo = data => {
    return axios({
        url: 'vip/updateUserInfo',
        method: 'POST',
        data: data,
    })
}

//用户信息导入
export const importVip = data => {
    return axios({
        url: 'vip/importVip',
        headers: {
            'Content-Type':"multipart/form-data"
        },
        method: 'POST',
        data: data
    })
}

//多用户批量新增课程
export const batchInsertVipLesson = data => {
    return axios({
        url: 'vip/batchInsertVipLesson',
        method: 'POST',
        data: data,
    })
}




// export const GETCODE = params => {
//     return axios({
//         url: '/admin/upload/download',
//         method: 'get',
//         responseType: 'blob', //响应为二进制流
//         params: params,
//     })
// }

// export const GETNUM = params => {
//     return axios({
//         url: 'index.php/api/get_data',
//         method: 'get',
//         //responseType: 'blob', //响应为二进制流
//         params: params,
//     })
// }
// export const GETTABLE = params => {
//     return axios({
//         url: 'index.php/api/get_data',
//         method: 'get',
//         //responseType: 'blob', //响应为二进制流
//         params: params,
//     })
// }
// export const GETNOW = params => {
//     return axios({
//         url: 'index.php/api/refresh',
//         method: 'get',
//         //responseType: 'blob', //响应为二进制流
//         params: params,
//     })
// }
